import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import styled from 'styled-components';
import { colors } from '../../constants';

const Div = styled.div`
  margin-top: 150px;
  
  @media (min-width: 1025px) {
    margin-top: 200px;
  }
`;

const Title = styled.div`
    h2 {
      font-size: 32px !important;
      margin: 0;
      color: ${colors.primary};
      text-align: center;
    }
`;

const Intro = styled.div`
  color: ${colors.primary};
  font-size: 16px;
  padding: 40px 50px;
  line-height: 2em;
  margin: 0 auto;
  text-align: left;
  
  @media (min-width: 500px) {
    font-size: 20px;
    line-height: 1.5em;
  }
  
  
  @media (min-width: 1024px) {
    font-size: 25px;
    line-height: 1.5em;
    padding: 40px 100px;
  }
  
  a {
    color: ${colors.primary};
    padding: 0 5px;
    border-bottom: 4px solid ${colors.link};
  }
`;

const Section = ({ transitionProperties, copy, icon, intro }) => {
  return (
      <Div>
        <ReactCSSTransitionGroup { ...transitionProperties } >
          <Title className="section__title" dangerouslySetInnerHTML={ { __html: copy } } />
        </ReactCSSTransitionGroup>
        <Intro className="section__intro" dangerouslySetInnerHTML={ { __html: intro } } />
      </Div>
  );
};

Section.propTypes = {
  copy: PropTypes.string,
  transitionProperties: PropTypes.object.isRequired
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section/Section.js